import { API_ENDPOINT, useJwtToken } from 'helper';
import { useGetIDsFromURL } from 'components/DeviceDetails/helper';
import { useQuery } from 'react-query';

export const fetchUpgradeRecords = async (
    { Thing_ID, UpdateID },
    accessToken
) => {
    const url = new URL(
        `${API_ENDPOINT}/devices/${Thing_ID}/upgrade-records${UpdateID ? `/${UpdateID}` : ''}`
    );

    try {
        const response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: accessToken,
            },
        });

        if (!response.ok) {
            throw new Error(await response.text());
        }
        return response.json();
    } catch (error) {
        console.error('Error fetching upgrade records:', error);
        return error;
    }
};

export const acknowledgeUpgradeRecord = async (
    { Thing_ID, UpdateID },
    accessToken
) => {
    const url = new URL(
        `${API_ENDPOINT}/devices/${Thing_ID}/upgrade-records/${UpdateID}/acknowledge`
    );
    try {
        const response = await fetch(url.toString(), {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Authorization: accessToken,
            },
        });

        console.log('Response: ', response);

        if (!response.ok) {
            throw new Error(await response.text());
        }

        return response.json();
    } catch (error) {
        console.error('Error acknowledging upgrade record:', error);
        return error;
    }
};

export const useUpgradeRecords = () => {
    const { Thing_ID, UpdateID } = useGetIDsFromURL();
    const token = useJwtToken();

    return useQuery(
        ['upgradeRecords', Thing_ID, UpdateID ?? ''],
        () => fetchUpgradeRecords({ Thing_ID, UpdateID }, token),
        {
            enabled: !!Thing_ID && !!token,
            select: (data) =>
                data?.Count === 1 ? data?.Items[0] : data?.Items,
        }
    );
};
